// components/private/paket/hooks/useRegistrationCheck.ts
import { useQuery } from "@tanstack/react-query";
import { axiosClient } from "@/lib/axiosClient";

export function useRegistrationCheck(
    participantId?: number | null,
    periodId?: number | null,
    enabled = false
) {
    return useQuery({
        queryKey: ["registration-check", participantId, periodId],
        queryFn: async () => {
            const { data } = await axiosClient.get(
                `/participants/${participantId}/registrations/check/${periodId}`
            );
            return data; // shape depends on backend { registered: boolean, ... }
        },
        enabled: Boolean(participantId && periodId) && enabled,
        staleTime: 1000 * 60 * 1, // 1 minute
        refetchOnWindowFocus: false,
        retry: 0,
    });
}
